import { useEffect, useState } from "react";
import { Radio, RadioGroup, FormControlLabel, Button, Dialog, DialogContent } from '@mui/material';
import { ApiRequest } from "GlobalFunctions";
import Box from "elements/Box";
import PaymentForm from "./Components/PaymentForm";
import PlansRadio from "./Components/PlansRadio";
import PlansButtons from "./Components/PlansButtons";
import { useSnackbar, withSnackbar } from 'notistack';
import { useNavigate } from "react-router-dom";
import ISwitch from "elements/ISwitch";

export default function Payment(props: any) {

    const {
        transfer_code = '',
    } = props;

    const [loading, setLoading] = useState(false);
    
    const navigate = useNavigate();
    const { enqueueSnackbar, closeSnackbar } = useSnackbar();

    const [plans, setPlans] = useState([]);
    const [billingCycle, setBillingCycle] = useState('yearly');
    const [selectedPlan, setSelectedPlan] = useState<string | null>(null);
    const [planInfo, setPlanInfo] = useState<any | null>(null);
    const [openDialog, setOpenDialog] = useState(false);
    const [selectedPrice, setSelectedPrice] = useState<string>('0');
    const [selectedPlanData, setSelectedPlanData] = useState<any | null>(null);

    useEffect(() => {
        getPlans();
    }, []);

    /*============================
    GET PLANS
    ============================*/
    const getPlans = async () => {
        await ApiRequest({
            url: '/plans/getPublicPlans',
            method: 'GET',
            query: {
                store_id: localStorage.getItem('store_id')
            },
            setResponse: (response: any) => {
                setPlans(response.plans);
                // Mantener 'yearly' por defecto en lugar de usar response.current_plan_type
                // setBillingCycle(response.current_plan_type)
                setSelectedPlan(response.current_plan_id);
            }
        });
        setLoading(false);
    };

    /*============================
    HANDLE BILLING CYCLE CHANGE
    ============================*/
    const handleBillingCycleChange = (cycle: string) => {
        setBillingCycle(cycle);
    };

    /*============================
    HANDLE PLAN CHANGE
    ============================*/
    useEffect(() => {
        if (selectedPlan){
            handlePlanChange(selectedPlan);
        }
    }, [billingCycle]);

    /*============================
    FORMAT PRICE
    ============================*/
    const formatPrice = (price: number) => {
        let priceText = "Free";
        if (Number(price) > 0) {
            priceText = `$${price} / Month`
        }
        return priceText;
    };

    /*============================
    HANDLE PLAN CHANGE
    ============================*/
    const handlePlanChange = (plan_id: any) => {
        console.log("handlePlanChange called with:", plan_id, "billingCycle:", billingCycle);
        setSelectedPlan(plan_id);

        // Find the selected plan from the plans array
        const planData: any = plans.find((plan: any) => plan.plan_id == plan_id);
        console.log("Found plan data:", planData);
        if (planData) {
            const price = billingCycle === 'yearly' 
                ? planData.yearly.price 
                : planData.monthly.price;
            console.log("Calculated price:", price, "for cycle:", billingCycle);
            setSelectedPrice(price);
            setSelectedPlanData(planData);
        }
    };

    /*============================
    PAY PLAN
    ============================*/
    const selectPlan = async (formValues = {}, amount = 0) => {
        setLoading(true);

        await ApiRequest({
            url: '/stores/selectStorePlan',
            method: 'POST',
            body: {
                ...formValues,
                amount: amount || Number(selectedPrice),
                plan_id: selectedPlan,
                plan_type: billingCycle,
                transfer_code: transfer_code
            },
            setResponse: async (response: any) => {
                console.log("UPDATE PLAN RESPONSE ",response);
                if (response.status === "success") {
                    localStorage.setItem('store_id', response.store_id);

                    enqueueSnackbar(response.message, { variant: 'success' });
                    setOpenDialog(false);
                    window.location.href = '/account';
                    
                    await getPlans();
                    
                } else {
                    enqueueSnackbar(response.message, { variant: 'error' });
                    
                }
                setLoading(false);
            }
        });

        
        
    };

    return (
        <>

            <div className='store-transfer-divider'>
                Select a plan
            </div>
            <div className='store-transfer-actions'>
                <span className='store-transfer-disclaimer'>*Before accepting the website transfer, choose a subscription plan to continue.</span>
                <ISwitch
                    label="Yearly Discount (22%)"
                    labelPlacement="start"
                    checked={billingCycle === 'yearly'}
                    onChange={(e: any) => handleBillingCycleChange(e.target.checked ? 'yearly' : 'monthly')}
                    name="yearlyDiscount"
                />
            </div>
        <div className="flex_container">
            <Box className="intent-auth_component custom_payment_container">
                <div className="input_group">

                  
                    <PlansButtons
                        plans={plans}
                        billingCycle={billingCycle}
                        handlePlanChange={handlePlanChange}
                        activePlan = {selectedPlan}
                        setOpenDialog={setOpenDialog}
                    />

                    
                    <Dialog 
                        open={openDialog} 
                        onClose={() => setOpenDialog(false)}
                        maxWidth="sm"
                        fullWidth
                    >
                        <DialogContent>
                            <PaymentForm 
                                selectedPlanData={selectedPlanData}
                                updatePlan={selectPlan} 
                                style="custom"
                                setOpenDialog={setOpenDialog}
                                selectedPrice={selectedPrice}
                                billingCycle={billingCycle}
                            />
                        </DialogContent>
                    </Dialog>
                    
                
                </div>
            </Box>
        </div>
        </>
    );
}


